import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconRefresh = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconRefresh.dimensions.width} ${IconRefresh.dimensions.height}`}
      {...otherProps}
    >
      <Path
        d="m5.3.818 3.433 1.856-3.38 1.99-.022-1.425c-.06.019-.108.03-.154.05-2.34.92-3.735 3.317-3.346 5.741.388 2.424 2.452 4.26 4.956 4.414 3.19.195 5.89-2.373 5.77-5.493a5.157 5.157 0 0 0-.894-2.724c-.183-.272-.09-.574.202-.673.191-.065.382.006.513.2.316.472.578.971.742 1.513.654 2.176.255 4.16-1.254 5.898-1.89 2.176-5.086 2.755-7.65 1.43C1.199 12.032.032 8.403 1.605 5.42c.773-1.467 1.972-2.474 3.564-3.025.109-.037.158-.078.154-.202-.016-.446-.016-.891-.021-1.375Z"
        fill={color || Color.premiumBlack}
      />
    </Svg>
  )
}

IconRefresh.dimensions = {
  width: 14,
  height: 15,
}

export default IconRefresh
